module.exports = __webpack_public_path__ + "static/media/Team 6 - Mate Gate.2909b543.png";